<template>
  <el-table :data="dataTable" highlight-current-row stripe border>
    <el-table-column label="请选择发送目录" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-button type="primary" @click="reSendMessage(scope.$index, scope.row)">{{scope.row.recedir}}</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>


<script>
import perApi from "@/api/filepersistent/Filepersistent.js";
export default {
  name: "ReSendOp",
  props: { filePathArray: { type: Array, default: null } },
  components: {},
  data() {
    return {
      params: {
        filePathArray: [],
        recedir: ""
      },
      dataTable: []
    };
  },
  mounted: function() {
    this.dataTableLoad();
  },
  methods: {
    dataTableLoad() {
      perApi.getCsDir().then(respData => (this.dataTable = respData.datarows));
    },
    // 重发
    reSendMessage(index, row) {
      this.$confirm("是否在" + row.recedir + "目录下重发选中数据", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.params.filePathArray = this.filePathArray;
        this.params.recedir = row.recedir;
        perApi.reSendMessage(this.params).then(() => {
          this.selectTable();
        });
      });
    }
  }
};
</script>
